export default {
  chosen_by_client: {
    label: 'Connaissez-vous la date de votre déménagement ?',
    options: {
      yes: 'Oui, c\'est une date fixe',
      yesFlex: 'Oui, je suis flexible',
      no: 'Non, pas encore',
    },
  },
  date: {
    labelDate: 'À quelle date souhaitez-vous déménager ?',
    labelPeriode: 'Sur quelle période souhaitez-vous déménager ?',
    labelPeriodeUnKnown: 'A quelle période pensez-vous déménager ?',
    placeholder: {
      start: 'Début',
      end: 'Fin',
      date: 'Date',
    },
    the: 'Le',
    between: 'Entre le',
    endThe: 'Et le',
  },
};
